module.exports = __webpack_public_path__ + "img/hc_pro_night_5.f7ba2f64.jpg";